/* global lazyload */
import 'lazyload';

import Abstract from './abstract';
import { onSendGTag } from './module';
import initCompanyPromotionBanner from '../shared/companyPromotionBanner';
import initMangaInterstitial from '../shared/mangaInterstitial';
import { insertInreadAd } from '../shared/inreadAdPlacement';

const lazyloadDescriptionImage = () => {
  const imagesLazyload = document.querySelectorAll('.trill-description .image-block .image-block__image');

  lazyload(imagesLazyload);
};

const onSendOriginalLinkGTag = (e) => {
  const link = e.currentTarget.getAttribute('href');

  onSendGTag('タップ', {
    event_category: '元記事を読む',
    event_label: 'タップ',
    link_url: link,
  });
};

const onSendClickArticleImageLinkGTag = (e) => {
  const link = e.currentTarget.getAttribute('href');

  onSendGTag('タップ', {
    event_category: '記事説明画像',
    event_label: 'タップ',
    link_url: link,
  });
};

const onSendMediumRelatedArticleLinkGTag = (e) => {
  const title = e.currentTarget.dataset.gaMediumRelatedArticleTitle;
  const link = e.currentTarget.getAttribute('href');

  onSendGTag('タップ', {
    event_category: 'メディア関連記事枠',
    event_label: title,
    link_url: link,
  });
};

const onSendRelatedArticleLinkGTag = (e) => {
  const title = e.currentTarget.dataset.gaRelatedArticleTitle;
  const link = e.currentTarget.getAttribute('href');

  onSendGTag('タップ', {
    event_category: 'あなたにおすすめの記事',
    event_label: title,
    link_url: link,
  });
};

const onSendRelatedTagsGTag = (e) => {
  const link = e.currentTarget.getAttribute('href');

  onSendGTag('タップ', {
    event_category: '記事関連キーワード',
    event_label: 'タップ',
    link_url: link,
  });
};

const onSendPVBoostLinkGTag = (e) => {
  const link = e.currentTarget.getAttribute('href');

  onSendGTag('タップ', {
    event_category: 'スポコン救済枠',
    event_label: 'タップ',
    link_url: link,
  });
};

const onSendClickMangaCreatorDetailLinkGTag = (e) => {
  const link_url = e.currentTarget.getAttribute('href');

  onSendGTag('タップ', {
    event_category: '作品をもっと見る',
    event_label: 'タップ',
    link_url,
  });
};

// PC — i-mobile direct interstitial tag. The spot differs between in-house and CP media.
const IMOBILE_INTERSTITIAL_SPOTS = {
  inhouse: { asid: 1933578, elementId: 'im-8dfda6895e8c43ceb8c5f9f70feb615b' },
  cp: { asid: 1940669, elementId: 'im-e4b6dc88bcb84c8498e2b0fad18cc8b6' },
};

const injectImobileInterstitial = () => {
  const spot = IMOBILE_INTERSTITIAL_SPOTS[window.mangaInterstitialGroup];
  if (!spot) return;

  // Idempotent: a bfcache-restored page keeps its already-injected container, so skip re-injecting.
  if (document.getElementById(spot.elementId)) return;

  const container = document.createElement('div');
  container.id = spot.elementId;
  document.body.appendChild(container);

  const loader = document.createElement('script');
  loader.async = true;
  loader.src = 'https://imp-adedge.i-mobile.co.jp/script/v1/spot.js?20220104';
  container.appendChild(loader);

  const push = document.createElement('script');
  push.text = '(window.adsbyimobile=window.adsbyimobile||[]).push('
    + `{pid:71224,mid:512544,asid:${spot.asid},type:"banner",display:"interstitial",elementid:"${spot.elementId}"})`;
  container.appendChild(push);
};

export default class ArticleDetailView extends Abstract {
  init() {
    this.getElement();

    this.addEvent();

    this.addGAM();
    this.setCompanyPromotionPattern();
    initMangaInterstitial(injectImobileInterstitial);
  }

  getElement() {
    this.originalLink = document.querySelector('.js-article-original-link');
    this.relatedMediumArticleLinks = Array.prototype.slice.call(document.querySelectorAll('.js-medium-related-article-link'));
    this.relatedArticleLinks = Array.prototype.slice.call(document.querySelectorAll('.js-related-article-link'));
    this.relatedTags = Array.prototype.slice.call(document.querySelectorAll('.js-related-tag'));
    this.ArticleDetailContainer = document.querySelector('.js-article-detail-container');
    this.pvboostLink = Array.prototype.slice.call(document.querySelectorAll('.js-article-pvboost-link'));

    this.articleDescriptionContainer = document.querySelector('.js-article-description-container')
      || document.querySelector('.js-sponsored-article-description-container');

    this.mangaCreatorDetailLink = document.querySelector('.js-article-detail-manga-creator-detail-link');
  }

  addEvent() {
    if (this.originalLink) this.originalLink.addEventListener('click', onSendOriginalLinkGTag);

    const pageviewContent = (window.dataLayer && window.dataLayer[0] && window.dataLayer[0].pageviewContent) || {};
    if (this.articleDescriptionContainer) {
      const excludeArticlePhoto = this.articleDescriptionContainer.dataset.excludeArticlePhoto === 'true';
      // Prefer server-rendered article id; dataLayer is absent when GA tracking is disabled (e.g. preview)
      const articleId = this.articleDescriptionContainer.dataset.articleId || pageviewContent.article_id;
      this.articleDescriptionContainer.querySelectorAll('.trill-description img').forEach((imageElement, index) => {
        if (excludeArticlePhoto) {
          // eslint-disable-next-line no-param-reassign
          imageElement.style.visibility = 'visible';
          return;
        }

        const newImageLinkElement = document.createElement('a');

        newImageLinkElement.setAttribute('rel', 'nofollow');

        // eslint-disable-next-line no-param-reassign
        imageElement.style.visibility = 'visible';
        newImageLinkElement.href = `/articles/${articleId}/photos/${index + 1}`;
        newImageLinkElement.className = 'image-block__link-container';
        newImageLinkElement.innerHTML = `
          ${imageElement.outerHTML}
        `;

        imageElement.insertAdjacentElement('beforebegin', newImageLinkElement);
        // eslint-disable-next-line no-param-reassign
        imageElement.style.display = 'none';
        newImageLinkElement.addEventListener('click', (event) => {
          onSendClickArticleImageLinkGTag(event);
        });
      });
      lazyloadDescriptionImage();
    }

    if (this.mangaCreatorDetailLink) this.mangaCreatorDetailLink.addEventListener('click', onSendClickMangaCreatorDetailLinkGTag);

    if (this.relatedMediumArticleLinks) {
      this.relatedMediumArticleLinks.forEach((el) => {
        el.addEventListener('click', onSendMediumRelatedArticleLinkGTag);
      });
    }

    if (this.relatedArticleLinks) {
      this.relatedArticleLinks.forEach((el) => {
        el.addEventListener('click', onSendRelatedArticleLinkGTag);
      });
    }

    if (this.relatedTags) {
      this.relatedTags.forEach((el) => {
        el.addEventListener('click', onSendRelatedTagsGTag);
      });
    }

    if (this.pvboostLink) {
      this.pvboostLink.forEach((el) => {
        el.addEventListener('click', onSendPVBoostLinkGTag);
      });
    }
  }

  addGAM() {
    const adHtml = '<div id="div-gpt-ad-1615857023689-0" style="text-align:center;"></div>';
    insertInreadAd(this.ArticleDetailContainer, adHtml);
  }

  setCompanyPromotionPattern() {
    const data = window.currentCompanyPromotionPatternData;
    if (!data || !data.gaValue) return;

    const el = document.querySelector('.js-company-promotion-pattern');
    if (!el) return;

    initCompanyPromotionBanner(el, onSendGTag, data.gaValue);
  }
}
